<template>
  <el-row class="zhb_consult_fitter">
    <el-input
      v-model="fitter.mobile"
      size="mini"
      clearable
      placeholder="手机号"
      @input="handleMobileChange"
    >
    </el-input>
    <el-select v-model="fitter.type" placeholder="类型" size="mini" clearable @change="handleTypeChange">
      <el-option label="工厂合作" :value="1"></el-option>
      <el-option label="服务咨询" :value="2"></el-option>
      <el-option label="数智赋能合作" :value="3"></el-option>
      <el-option label="咨询与反馈" :value="4"></el-option>
    </el-select>
  </el-row>
</template>

<script>
export default {
  name: 'ZhbConsultFitter',
  props: {
    fitter: {
      type: Object,
      default: () => {
        return {
          mobile: '',
          type: ''
        }
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
    handleMobileChange (val) {
      this.$emit('search', this.fitter.mobile)
    },
    handleTypeChange (val) {
      this.$emit('search', false)
    }
  }
}
</script>

<style lang="stylus" scoped>
.zhb_consult_fitter >>> .el-input {
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/zhb_consult/ZhbConsultFitter.vue